import { Route } from "react-router-dom";
import { Dashboard } from "./component/Dashboard/Dashboard";
import { Diagnosis } from "./component/Diagnosis/Diagnosis";
import { Prescription } from "./component/Prescription/Prescription";
import Procedures from "./component/Procedures/Procedures";
import Consultation from "./component/Consultation/Consultation";
import { Billing } from "./component/Billing/Billing";
import { Pharmacy } from "./component/Billing/Pharmacy";
const Router = ({
  selectedBanner,
  setSelectedBanner,
  verticalCreative,
  reactCreative,
  horizontalCreative,
  popupCreative,
}) => {
  return (
    <>
      <Route
        path="/People/dashboard"
        component={(props) => (
          <Dashboard {...props} verticalCreative={verticalCreative} />
        )}
      />
      <Route
        path="/People/Consultation"
        component={(props) => (
          <Consultation
            {...props}
            selectedBanner={selectedBanner}
            setSelectedBanner={setSelectedBanner}
            reactCreative={reactCreative}
          />
        )}
      />
      <Route
        path="/People/Procedures"
        component={(props) => (
          <Procedures
            {...props}
            selectedBanner={selectedBanner}
            setSelectedBanner={setSelectedBanner}
            reactCreative={reactCreative}
          />
        )}
      />
      <Route
        path="/People/Diagnosis"
        component={(props) => (
          <Diagnosis
            {...props}
            selectedBanner={selectedBanner}
            setSelectedBanner={setSelectedBanner}
            horizontalCreative={horizontalCreative}
            popupCreative={popupCreative}
          />
        )}
      />
      <Route
        path="/People/Prescription"
        component={(props) => (
          <Prescription
            {...props}
            selectedBanner={selectedBanner}
            setSelectedBanner={setSelectedBanner}
            reactCreative={reactCreative}
          />
        )}
      />
      <Route
        path="/People/billing"
        component={(props) => (
          <Billing
            {...props}
            verticalCreative={verticalCreative}
            horizontalCreative={horizontalCreative}
          />
        )}
      />
      <Route path="/People/Pharmacy" component={Pharmacy} />
    </>
  );
};
export default Router;
